import { render, staticRenderFns } from "./TableRowHead.vue?vue&type=template&id=56ab3cb6&"
import script from "./TableRowHead.vue?vue&type=script&lang=js&"
export * from "./TableRowHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ab3cb6')) {
      api.createRecord('56ab3cb6', component.options)
    } else {
      api.reload('56ab3cb6', component.options)
    }
    module.hot.accept("./TableRowHead.vue?vue&type=template&id=56ab3cb6&", function () {
      api.rerender('56ab3cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowHead.vue"
export default component.exports